import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Analytics from './pages/Analytics';
import Integrations from './pages/Integrations';
import Investments from './pages/Investments';
import Loans from './pages/Loans';
import Content from './pages/Content';
import System from './pages/System';
import Business from './pages/Business';
import Login from './pages/Login';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(true); // For demo purposes, set to true
  // Mock login function
  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" data-id="element-3" /> : <Login onLogin={handleLogin} data-id="element-4" />} data-id="element-2" />
        <Route path="/*" element={isAuthenticated ? <DashboardLayout data-id="element-6">
                <Routes data-id="element-7">
                  <Route path="/" element={<Dashboard data-id="element-9" />} data-id="element-8" />
                  <Route path="/users" element={<Users data-id="element-11" />} data-id="element-10" />
                  <Route path="/analytics" element={<Analytics data-id="element-13" />} data-id="element-12" />
                  <Route path="/integrations" element={<Integrations data-id="element-15" />} data-id="element-14" />
                  <Route path="/investments" element={<Investments data-id="element-17" />} data-id="element-16" />
                  <Route path="/loans" element={<Loans data-id="element-19" />} data-id="element-18" />
                  <Route path="/content" element={<Content data-id="element-21" />} data-id="element-20" />
                  <Route path="/system" element={<System data-id="element-23" />} data-id="element-22" />
                  <Route path="/business" element={<Business data-id="element-25" />} data-id="element-24" />
                </Routes>
              </DashboardLayout> : <Navigate to="/login" data-id="element-26" />} data-id="element-5" />
      </Routes>
    </Router>;
}